import React from "react";
import TextInput from "./TextInput";

export default function ({
  label,
  name,
  register,
  errorMessage = "",
  classes = "",
  parentClasses = "",
  required = false,
  autoComplete = ""
}) {
  return (
    <TextInput
      label={label}
      classes={classes}
      parentClasses={parentClasses}
      name={name}
      register={register}
      autoComplete={autoComplete}
      errorMessage={errorMessage}
      type="email"
      required={required}
    />
  );
}